var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React from 'react';

var ChupaChups = function ChupaChups(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "-13437 2325 26 44",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), React.createElement("title", null, title), React.createElement("defs", null, React.createElement("clipPath", {
    id: "ChupaChups_a"
  }, React.createElement("path", {
    d: "M-13437 2325h26v44h-26z"
  }))), React.createElement("g", {
    "data-name": "Chupa Chups \u2013 1",
    clipPath: "url(#ChupaChups_a)"
  }, React.createElement("path", {
    fill: "transparent",
    d: "M-13437 2325h26v44h-26z"
  }), React.createElement("g", {
    "data-name": "Group 654",
    transform: "translate(305 139)"
  }, React.createElement("path", {
    "data-name": "Rectangle 107",
    d: "M-13730.877 2198.452h3.19V2230h-3.19z"
  }), React.createElement("ellipse", {
    "data-name": "Ellipse 131",
    cx: 13,
    cy: 12.68,
    rx: 13,
    ry: 12.68,
    transform: "translate(-13742 2186)",
    fill: "currentColor"
  }))));
};

export default ChupaChups;